import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link, useNavigate } from 'react-router-dom';
import {
  Typography,
} from '@material-ui/core';
import { successStoriesData } from '../../data/successStoriesData';

const styles = (theme) => ({
  section: {
    padding: '60px 0',
    width: '100%',
    borderBottom: '1px solid #e0e0e0',
    marginBottom: '60px',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  sectionNumber: {
    fontSize: '14px',
    letterSpacing: '3px',
    color: '#d4145a',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
    marginBottom: '15px',
  },
  sectionTitleText: {
    fontSize: '48px',
    marginTop: '15px',
    marginBottom: '20px',
    fontWeight: 700,
    color: '#1a1a1a',
    fontFamily: '"Georgia", serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
    },
  },
  sectionDescription: {
    fontSize: '18px',
    color: '#555',
    maxWidth: '700px',
    margin: '0 auto',
    fontFamily: '"Segoe UI", sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '40px',
    flexWrap: 'wrap',
    '& .MuiTab-root': {
      minWidth: 'auto',
      padding: '10px 20px',
      textTransform: 'uppercase',
      fontSize: '14px',
      letterSpacing: '1px',
      fontWeight: 600,
      fontFamily: '"Segoe UI", sans-serif',
    },
    '& .Mui-selected': {
      color: '#d4145a',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#d4145a',
    },
  },
  tabPanel: {
    padding: 0,
    width: '100%',
  },
  casesEditorial: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '50px',
    marginBottom: '60px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  caseEditorial: {
    padding: '45px',
    background: 'white',
    border: '2px solid #e0e0e0',
    transition: 'all 0.3s',
    '&:hover': {
      borderColor: '#d4145a',
      boxShadow: '0 10px 40px rgba(212, 20, 90, 0.1)',
    },
  },
  caseCategory: {
    fontSize: '11px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: 'white',
    background: '#d4145a',
    display: 'inline-block',
    padding: '6px 16px',
    marginBottom: '20px',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
  },
  caseTitle: {
    fontSize: '26px',
    marginBottom: '20px',
    color: '#1a1a1a',
    fontFamily: '"Georgia", serif',
    fontWeight: 600,
  },
  caseDescription: {
    fontSize: '16px',
    lineHeight: 1.8,
    color: '#555',
    fontFamily: '"Segoe UI", sans-serif',
  },
  readMore: {
    display: 'inline-block',
    marginTop: '20px',
    color: '#d4145a',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: '"Segoe UI", sans-serif',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

function RecentCaseStudies(props) {
  const { classes } = props;
  const navigate = useNavigate();
  
  const handleCaseClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <section className={classes.section} id="cases">
      <div className={classes.sectionHeader}>
        <div className={classes.sectionNumber}>IV. CASE STUDIES</div>
        <Typography variant="h2" className={classes.sectionTitleText}>
          Recent Success Stories
        </Typography>
        <Typography className={classes.sectionDescription}>
          Explore our successful case studies across different legal practice areas
        </Typography>
      </div>
      
      <div className={classes.casesEditorial}>
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['high-court-case'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['high-court-case'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['high-court-case'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['high-court-case'].shortDescription}
          </Typography>
          <Link to={successStoriesData['high-court-case'].path} className={classes.readMore}>Read More →</Link>
        </div>
        
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['criminal-appeal'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['criminal-appeal'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['criminal-appeal'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['criminal-appeal'].shortDescription}
          </Typography>
          <Link to={successStoriesData['criminal-appeal'].path} className={classes.readMore}>Read More →</Link>
        </div>
        
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['maintenance-case'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['maintenance-case'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['maintenance-case'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['maintenance-case'].shortDescription}
          </Typography>
          <Link to={successStoriesData['maintenance-case'].path} className={classes.readMore}>Read More →</Link>
        </div>
        
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['property-registration'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['property-registration'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['property-registration'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['property-registration'].shortDescription}
          </Typography>
          <Link to={successStoriesData['property-registration'].path} className={classes.readMore}>Read More →</Link>
        </div>
        
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['consumer-dispute'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['consumer-dispute'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['consumer-dispute'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['consumer-dispute'].shortDescription}
          </Typography>
          <Link to={successStoriesData['consumer-dispute'].path} className={classes.readMore}>Read More →</Link>
        </div>
        
        <div className={classes.caseEditorial} onClick={() => handleCaseClick(successStoriesData['tax-appeal'].path)}>
          <div className={classes.caseCategory}>{successStoriesData['tax-appeal'].category}</div>
          <Typography className={classes.caseTitle}>
            {successStoriesData['tax-appeal'].title}
          </Typography>
          <Typography className={classes.caseDescription}>
            {successStoriesData['tax-appeal'].shortDescription}
          </Typography>
          <Link to={successStoriesData['tax-appeal'].path} className={classes.readMore}>Read More →</Link>
        </div>
      </div>
    </section>
  );
}

export default withStyles(styles)(RecentCaseStudies);
